module.exports = "/_next/static/images/documentalt-81ea840b4f143244b796943405d47ab5.svg";